import userInfo from "../../function/userInfo";
import * as API from "../ApiConfig";
export default {
  DoCreatePaymentTransferFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/CreatePaymentFile", input);
  },
  DoConfirmPaidPaymentFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/ConfirmPaidPaymentFile", input);
  },
  DoValidateCreatePayment(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/ValidateCreatePayment", input);
  },
  DoGetPaymentFileDetail(input) {
    return API.peakRealTimeAPI
      .post("/api/PaymentFile/GetPaymentFileDetail", input, userInfo.SetHeaderService())
      .then((res) => {
        return res.data;
      });
  },
  DoValidateVoidPaymentFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/ValidateVoidPaymentFile", input);
  },
  DoVoidPaymentFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/VoidPaymentFile", input);
  },
  DoGeneratePaymentFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/GeneratePaymentFile", input);
  },
  DoUpdateStatusPaymentFile(input) {
    return API.peakRealTimeAPI.post("/api/PaymentFile/UpdateStatusPaymentFile", input);
  },
};
